import React from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  Paper,
  Skeleton,
} from "@mui/material";

export function BackdropComponent(props: any): React.ReactElement {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme: { zIndex: { drawer: number } }) =>
          theme.zIndex.drawer + 1,
      }}
      open={props.visible}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export function BackdropSkeletonComponent(props: any): React.ReactElement {
  return (
    <>
      {props.loading ? (
        <Box sx={{ width: "100%", padding: 4 }}>
          <Paper
            elevation={3}
            sx={{
              margin: 2,
              padding: 2,
              textAlign: "center",
            }}
          >
            <Skeleton />
            <Skeleton animation="wave" />
            <Skeleton animation={false} />
          </Paper>
        </Box>
      ) : (
        props.children
      )}
    </>
  );
}
